<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-28 10:42:56
 * @LastEditors: luckymiaow
-->
<script lang="ts" setup>
import { useAttrs, useSlots, withDefaults } from 'vue';
import { Button, Upload } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import type { Api } from '../types';
import useSlot from '../../hooks/useSlot';
import { useUpload } from './useUpload';

interface IUpload {
  hiddenList?: boolean;

  api?: Api;

  params?: any;

  multiple?: boolean;

  maxSize?: number;

  maxCount?: number;

  accept?: string;

  uploadNow?: boolean; // 立即上传

  readOnly?: boolean;
  bordered?: boolean;
  readOnlyStyle?: object | null;
  readOnlyClassName?: string | null;
}

const props = withDefaults(defineProps<IUpload>(), {
  accept: '*',
  multiple: false,
  uploadNow: true,
  hiddenList: false,
  readOnly: undefined,
});

const emit = defineEmits(['completeCheckType', 'fileResult']);

const { getBindValue, beforeUpload } = useUpload(props, { emit, attrs: useAttrs() });

const { useExcludeSlots } = useSlot({ slots: useSlots() }, ['iconRender', 'default']);
</script>

<template>
  <Upload
    name="file"
    v-bind="getBindValue"
    :disabled="getBindValue?.readOnly"
    :before-upload="beforeUpload"
    :class="{ upload: hiddenList }"
  >
    <template #default>
      <slot>
        <Button>
          <slot name="iconRender">
            <UploadOutlined />
          </slot>
          选择文件
        </Button>
      </slot>
    </template>
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </Upload>
</template>

<style scoped lang="less">
.upload {
  :deep(.ant-upload-list) {
    display: none;
  }
}
</style>
